import PropTypes from "prop-types";
import React from "react";
import { JsonEditor as Editor } from "react-jsondata-editor";
import style from "./style.module.scss";

const myStyle = {
  theme: {
    color: "#343a40",
    hoverColor: "#d3d3d380",
  },
  bannerStyle: {
    hoverColor: "#343a40",
    fontColor: "white",
    font: '14px/24px "Fira Sans", sans-serif',
  },
  keyStyle: {
    color: "black",
    font: '14px/20px "Fira Sans", sans-serif',
  },
  valueStyle: {
    font: "14px/20px Arial, Helvetica, sans-serif",
  },
};

/**
 * @param {object} props
 * @param {string} props.stateValue
 * @param {?function} props.onChange
 */
const JsonEditor = props => {
  const { stateValue, onChange } = props;

  const handleChange = value => {
    let stringJson;
    const jsonValue = JSON.parse(value || "{}");
    if (jsonValue && Object.keys(jsonValue).length > 0) {
      stringJson = JSON.stringify(jsonValue);
    }
    onChange(stringJson);
  };

  return (
    <div className={style.inputJson}>
      <Editor
        jsonObject={stateValue}
        theme={myStyle.theme}
        bannerStyle={myStyle.bannerStyle}
        keyStyle={myStyle.keyStyle}
        valueStyle={myStyle.valueStyle}
        buttonStyle={myStyle.buttonStyle}
        onChange={handleChange}
      />
    </div>
  );
};

JsonEditor.propTypes = {
  stateValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

JsonEditor.defaultProps = {
  stateValue: "",
  onChange: () => {},
};

export default JsonEditor;
